import React, { useState } from 'react';
import Slider from '@mui/material/Slider';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {
	Typography,
	Box,
	Popover,
	ThemeProvider,
	DialogActions,
	Grid,
} from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { colors } from '../../../theme/color-palette';
import { theme } from '../../../theme/theme';

const useStyles = makeStyles(() => ({
	cancelButton: {
		borderRadius: '100px',
	},
	applyButton: {
		borderRadius: '100px',
	},
}));

const Slidder = ({ defaultValue, getValue, updateReplInstock }) => {
	const [value, setValue] = useState(defaultValue);
	const [anchorEl, setAnchorEl] = useState(null);

	const classes = useStyles();

	const handleClickOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		getValue(defaultValue);
		setAnchorEl(null);
	};

	const handleApply = () => {
		getValue(value);
		updateReplInstock(value);
		setAnchorEl(null);
	};

	const handleSliderInput = (e, newValue) => {
		setValue(newValue);
	};

	const handleInputChange = (e) => {
		const value = e.target.value;
		setValue(value === '' ? '' : Number(value));
		if (value > 100) {
			setValue(100);
		}
		if (value < 0) {
			setValue(0);
		}
	};

	const open = Boolean(anchorEl);
	const id = open ? 'simple-popover' : undefined;

	return (
		<ThemeProvider theme={theme}>
			<Button
				data-testid="editBtn"
				onClick={handleClickOpen}
				sx={{
					textTransform: 'none',
					color: colors.PURPLE,
					borderRadius: 100,
					padding: '0px',
					height: '32px',
					margin: '0px 16px',

					'&:hover': {
						backgroundColor: 'transparent',
					},
					'.MuiTouchRipple-child': {
						color: '#D5D6D8',
					},
				}}>
				<Typography
					sx={{ fontWeight: 700, fontSize: '12px', lineHeight: '16px' }}>
					Edit
				</Typography>
			</Button>
			<Popover
				sx={{
					'& .MuiPopover-paper': {
						width: '400px',
						borderRadius: '15px',
						boxShadow:
							'0px -1px 4px 0px rgba(0, 0, 0, 0.10), 0px 5px 10px 3px rgba(0, 0, 0, 0.15)',
					},
				}}
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description">
				<DialogTitle
					id="alert-dialog-title"
					sx={{
						fontFamily: 'Bogle-Regular',
						fontSize: '14px',
						fontWeight: 700,
						padding: '24px 24px 0 24px',
					}}>
					Edit threshold for RepIenishable InStock %
				</DialogTitle>
				<DialogContent>
					<Typography
						sx={{
							fontFamily: 'Bogle-Regular',
							fontSize: '12px',
							padding: '4px 0px 24px 0px',
						}}>
						The corresponding table column will also be updated.
					</Typography>
					<Grid
						sx={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'space-between',
							alignItems: 'center',
							fontSize: '14px',
							color: colors.LIGHT_GRAY_HEX,
							gap: '20px',
						}}
						spacing={2}>
						<Box
							sx={{
								display: 'flex',
								width: '100%',
								alignItems: 'center',
							}}>
							<Grid
								item
								sx={{
									marginRight: '12px',
								}}>
								0
							</Grid>
							<Slider
								value={typeof value === 'number' ? value : 0}
								onChange={handleSliderInput}
								aria-labelledby="slider-with-input"
								sx={{
									width: '100%',
									'& .MuiSlider-thumb': {
										color: '#3c228a',
									},
									'& .MuiSlider-track': {
										color: '#3c228a',
									},
									'& .MuiSlider-rail': {
										color: '#6246B5',
									},
									'& .MuiSlider-': {
										color: '#3c228a',
									},
									'& .MuiSlider-thumb:hover': {
										boxShadow: '0 0 0 10px rgba(209,203,228,0.3) !important',
									},
								}}
							/>
							<Grid
								item
								sx={{
									marginLeft: '12px',
								}}>
								100%
							</Grid>
						</Box>
						<Box
							sx={{
								display: 'flex',
								alignItems: 'center',
								gap: '8px',
							}}>
							<OutlinedInput
								data-testid="inputField"
								value={value}
								onChange={handleInputChange}
								sx={{
									width: '48px',
									height: '95%',
									'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button':
										{
											WebkitAppearance: 'none',
											margin: 0,
										},
									'input[type=number]': {
										MozAppearance: 'textfield',
									},
								}}
								type="number"
								inputProps={{
									style: {
										padding: 7,
									},
								}}
							/>
							<span style={{ marginLeft: '4%' }}>%</span>
						</Box>
					</Grid>
				</DialogContent>

				<DialogActions
					sx={{
						borderTop: '1px solid #dadce0',
						display: 'flex',
						justifyContent: 'flex-end',
						padding: '16px 24px',
					}}>
					<Button
						data-testid="cancelBtn"
						variant="outlined"
						sx={{
							borderRadius: '100px',
							textTransform: 'none',
							fontWeight: 700,
						}}
						onClick={handleClose}
						className={classes.cancelButton}>
						Cancel
					</Button>
					<Button
						data-testid="applyBtn"
						variant="contained"
						sx={{
							borderRadius: '100px',
							textTransform: 'none',
							fontWeight: 700,
							boxShadow: 0,
						}}
						className={classes.applyButton}
						onClick={handleApply}>
						Apply
					</Button>
				</DialogActions>
			</Popover>
		</ThemeProvider>
	);
};

Slidder.propTypes = {
	defaultValue: PropTypes.number,
	getValue: PropTypes.func,
	updateReplInstock: PropTypes.func,
};

export default Slidder;
